// CreditsPage.jsx
import React from "react";
import { Container, Box, Grid, Typography } from "@mui/material"; import AccountSidebarNav from "../../Components/AccountComponents/AccountSideNacv";
import EmptyState from "../../Components/AccountComponents/EmptyState";
;

export default function Credits() {
    return (
        <Container maxWidth={false} sx={{
            py: 2,
            // Responsive maxWidth for different screen sizes
            maxWidth: {
                xs: '100%',  // Mobile
                sm: '95%',   // Small tablets
                md: '92%',   // Tablets and small laptops
                lg: '90%',   // Large screens
                xl: '90%',   // Very large displays
            },
            mx: 'auto', // Center align container
        }}>
            {/* ✅ Breadcrumb */}
            <Box
                sx={{
                    mb: 2,
                    pb: 2,
                    borderBottom: "1px solid #e5e5e5",
                }}
            >
                <Typography
                    sx={{
                        textTransform: "uppercase",
                        fontSize: "12px",
                        letterSpacing: "0.05em",
                        color: "text.secondary",
                    }}
                >
                    <span style={{ color: "#000" }}>My Account</span>
                    <span style={{ margin: "0 8px" }}>{">"}</span>
                    <span style={{ color: "#000" }}>My Credits</span>
                </Typography>
            </Box>

            {/* ✅ Layout */}
            <Grid container spacing={4}>
                {/* Sidebar */}
                <Grid item xs={12} md={3}>
                    <AccountSidebarNav active="My Credits" />
                </Grid>

                {/* Empty State Content */}
                <Grid item xs={12} md={9}>
                    <EmptyState
                        imageSrc="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/credit-card-or-wallet-icon-AesXaVmXi3xq5Idx1mW8SmyZ14LHLa.jpg"
                        imageAlt="No credits"
                        title="No credits available!"
                        subtitle="Earn credits by shopping with us."
                        buttonText="Start Shopping"
                        buttonHref="/"
                    />
                </Grid>
            </Grid>
        </Container>
    );
}
